<div  class="modal fade show" aria-hidden="true" style="display: block;">

    <div >
        <div >
            <div >

                <div class="row">
                    <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                            <div class="ibox-title">
                                <h3>Buscador</h3>

                            </div>
                            <div class="ibox-content">
                                <div class="row">


                                    <div class="col-sm-12">


                                        <p>Utiliza los criterios para reducir la búsqueda.</p>

                                        <form role="form">
                                            <div class="form-group"><label>Criterio1</label>

                                             <input class="form-control" type="text" #answer (keyup)="onKeyUp(answer.value)" autofocus autocomplete="off" >



                                                    </div>
                                            <div class="form-group"><label>Criterio2</label> <input type="password" placeholder="Introducir texto para la buscar..."
                                                    class="form-control"></div>
                                            <div>
                                                <button class="btn btn-sm btn-primary col-sm-12" type="submit"><strong>Buscar</strong></button>
                                            </div>
                                              <div>
                                                <button class="btn btn-sm btn-primary col-sm-12" type="submit" value="hola" ><strong>{{'General.close' | translate}}</strong></button>
                                            </div>
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                            <div class="ibox-title">
                                <h5>{{ 'General.search.results' | translate }}</h5>

                            </div>
                            <div class="ibox-content">
                               <!--  <div class="row">
                                   div class="col-sm-7 m-b-xs"> <label class="btn btn-sm btn-white"> Ordenar por: </label>
                                        <select class="input-sm form-control input-s-sm inline">
                                    <option value="0">Option 1</option>
                                    <option value="1">Option 2</option>
                                    <option value="2">Option 3</option>
                                    <option value="3">Option 4</option>
                                </select>
                                    </div
                                    <div class="col-sm-12 m-b-xs">
                                        <div data-toggle="buttons" class="btn-group">
                                            <label class="btn btn-sm btn-white"> <input type="radio" id="option1" name="options"> 1 </label>
                                            <label class="btn btn-sm btn-white active"> <input type="radio" id="option2" name="options"> 2 </label>

                                        </div>
                                    </div>

                                </div>-->
                                <div class="table-responsive">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>

                                                <th></th>
                                                <th>col1 </th>

                                                <th>col2</th>
                                                <th>Date</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div class="icheckbox_square-green checked" style="position: relative;">
                                                        <input type="checkbox" checked="" name="input[]" >
                                                    </div>
                                                </td>
                                                <td>Project<small>This is example of project</small></td>

                                                <td>20%</td>
                                                <td>Jul 14, 2013</td>

                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="icheckbox_square-green" style="position: relative;"><input type="checkbox"   name="input[]"  >

                                                    </div>
                                                </td>
                                                <td>Alpha project</td>

                                                <td>40%</td>
                                                <td>Jul 16, 2013</td>

                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="icheckbox_square-green" style="position: relative;"><input type="checkbox"   name="input[]"  >

                                                    </div>
                                                </td>
                                                <td>Betha project</td>

                                                <td>75%</td>
                                                <td>Jul 18, 2013</td>

                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="icheckbox_square-green" style="position: relative;"><input type="checkbox"   name="input[]"  >

                                                    </div>
                                                </td>
                                                <td>Gamma project</td>

                                                <td>18%</td>
                                                <td>Jul 22, 2013</td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>